var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8888 0C6.34371 0 2.68593 3.39124 2.68593 7.58931V10.6363C1.4176 10.6363 0.388794 11.5546 0.388794 12.6868V23.9495C0.388794 25.0816 1.4176 26 2.68593 26H19.0917C20.36 26 21.3888 25.0816 21.3888 23.9495V12.6868C21.3888 11.5546 20.36 10.6363 19.0917 10.6363V7.58931C19.0917 3.39097 15.4339 0 10.8888 0ZM10.8888 2.94541C13.7979 2.94541 16.1382 5.02263 16.1382 7.60765V10.6267L5.63944 10.6277V7.60762C5.63944 5.02258 7.97968 2.94541 10.8888 2.94541ZM10.8888 14.4777C12.1571 14.4777 13.1859 15.4035 13.1859 16.5464C13.1859 17.2723 12.7691 17.9127 12.1403 18.2826C12.1751 18.3884 12.2014 18.4986 12.2014 18.6151V20.9788C12.2014 21.6331 11.6158 22.1602 10.8888 22.1602C10.1618 22.1602 9.57617 21.6331 9.57617 20.9788V18.6151C9.57617 18.4996 9.60372 18.3884 9.63725 18.2826C9.00847 17.9138 8.59167 17.2734 8.59167 16.5464C8.59167 15.4046 9.62047 14.4777 10.8888 14.4777Z",
    fill: "#BF202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/iconLock.f856e1b3c21b015bece8762896ba0ef7.svg";
export { ForwardRef as ReactComponent };